// Metadata keys of @nestjs/swagger's @ApiProperty(). @nestjs/swagger itself is not imported, because this
// package also runs in browsers.
export const API_MODEL_PROPERTIES = 'swagger/apiModelProperties';
export const API_MODEL_PROPERTIES_ARRAY = 'swagger/apiModelPropertiesArray';
/** Stores OpenAPI property metadata where @nestjs/swagger's @ApiProperty() does, over any existing metadata. */
export function defineApiPropertyMetadata(prototype, key, metadata) {
    var _a;
    if (typeof Reflect !== 'object' ||
        typeof Reflect.getMetadata !== 'function') {
        return;
    }
    const entries = (_a = Reflect.getMetadata(API_MODEL_PROPERTIES_ARRAY, prototype)) !== null && _a !== void 0 ? _a : [];
    if (!entries.includes(`:${key}`)) {
        Reflect.defineMetadata(API_MODEL_PROPERTIES_ARRAY, [...entries, `:${key}`], prototype);
    }
    Reflect.defineMetadata(API_MODEL_PROPERTIES, Object.assign(Object.assign({}, Reflect.getMetadata(API_MODEL_PROPERTIES, prototype, key)), metadata), prototype, key);
}
/**
 * Describes a property in the server's OpenAPI document like @nestjs/swagger's @ApiProperty(), for types the
 * CLI plugin cannot describe, such as string unions and JSON-encoded query values. The options are stored as
 * given, so pass them in @ApiProperty()'s stored form: `type` as a constructor or an OpenAPI type name, and
 * `enum` as an array of values. `required` comes from the plugin when omitted.
 */
export function ApiPropertyMetadata(metadata) {
    return (target, key) => defineApiPropertyMetadata(target, String(key), metadata);
}
